<app-notification [errorMsg]="errorMsg"></app-notification>

<div class="dual-list-container">
  <!-- Available Columns -->
  <div class="list-panel">
    <div class="list-header">
      <i class="pi pi-list" style="margin-right: 8px;"></i>
      <span>Available Columns ({{sourceColumns.length}})</span>
    </div>
    <input type="text"
      pInputText
      [(ngModel)]="sourceFilter"
      placeholder="Search columns..."
      class="filter-input" />
    <div class="list-content">
      @for (col of getFilteredSource(); track col) {
        <div
          class="list-item"
          [class.selected]="isSourceSelected(col)"
          (click)="toggleSourceSelection(col)">
          <span>{{col.fieldName}}</span>
        </div>
      }
      @if (getFilteredSource().length === 0) {
        <div class="empty-message">
          No columns available
        </div>
      }
    </div>
  </div>

  <!-- Transfer Buttons -->
  <div class="transfer-buttons">
    <button pButton
      type="button"
      icon="pi pi-angle-right"
      (click)="moveToTarget()"
      [disabled]="selectedSource.length === 0"
    class="p-button-sm"></button>
    <button pButton
      type="button"
      icon="pi pi-angle-double-right"
      (click)="moveAllToTarget()"
      [disabled]="sourceColumns.length === 0"
    class="p-button-sm"></button>
    <button pButton
      type="button"
      icon="pi pi-angle-left"
      (click)="moveToSource()"
      [disabled]="selectedTarget.length === 0"
    class="p-button-sm"></button>
    <button pButton
      type="button"
      icon="pi pi-angle-double-left"
      (click)="moveAllToSource()"
      [disabled]="targetColumns.length === 0"
    class="p-button-sm"></button>

    <button pButton
      type="button"
      icon="pi pi-angle-up"
      (click)="moveUp()"
      [disabled]="selectedTarget.length === 0"
      title="Move Up"
    class="p-button-sm"></button>
    <button pButton
      type="button"
      icon="pi pi-angle-down"
      (click)="moveDown()"
      [disabled]="selectedTarget.length === 0"
      title="Move Down"
    class="p-button-sm"></button>
  </div>

  <!-- Selected Columns -->
  <div class="list-panel">
    <div class="list-header">
      <i class="pi pi-check-circle" style="margin-right: 8px;"></i>
      <span>Selected Columns ({{targetColumns.length}})</span>
    </div>
    <input type="text"
      pInputText
      [(ngModel)]="targetFilter"
      placeholder="Search columns..."
      class="filter-input" />
    <div class="list-content">
      <!-- Show default columns as fixed, non-editable -->
      @for (col of defaultColumns; track col) {
        <div class="list-item fixed-column disabled-column">
          <span>{{col.fieldName}} <small class="text-muted">(Default, cannot edit)</small></span>
        </div>
      }
      <!-- Show user-selected columns -->
      @for (col of getFilteredTarget(); track col) {
        <div class="list-item"
          [class.selected]="isTargetSelected(col)"
          (click)="toggleTargetSelection(col)">
          <span>{{col.fieldName}}</span>
        </div>
      }
      @if (getFilteredTarget().length === 0 && defaultColumns.length === 0) {
        <div class="empty-message">
          No columns selected
        </div>
      }
    </div>
  </div>
</div>

<div class="save-button-container">
  <button
    type="button"
    title="Save Changes"
    class="btn btn-primary"
    [disabled]="saving"
    (click)="onSave()">
    {{saving ? 'Saving...' : 'Save Changes'}}
  </button>
</div>